export const saveDraftCopy = {
  header: '',
  description: '',
  cancelBtnText: '',
  confirmBtnText: '',
  successToast: '',
};
